"use strict";

jQuery(document).ready(function ($) {
  if ($('#js-body').find('.js-tabs').length) {
    var hasHash = function hasHash() {
      if (window.location.hash != "") {
        var hash = window.location.hash;
        $('[data-slug]').each(function () {
          if ($(this).data('slug') == hash) {
            $(this).click();
          }
        });
      }

      ;
    };

    var editPositions = function editPositions(index) {
      // $('.js-tab-item[data-tab="tab_'+ index +'"]').addClass('left');
      $('.js-tab-item[data-tab="tab_' + index + '"]').prevAll('.js-tab-item').removeClass('active right').addClass('left');
      $('.js-tab-item[data-tab="tab_' + index + '"]').nextAll('.js-tab-item').removeClass('active left').addClass('right');
    };

    var tabsProduct = function tabsProduct() {
      $toggles.removeClass('active');
      $('.js-tab-toggle[data-target=' + tab + ']').addClass('active');
      var $currentItem = $('.js-tab-toggle.active'),
          itemIndex = $currentItem.data('target'),
          $target = $('.js-tab-item[data-tab="tab_' + itemIndex + '"]');
      editPositions(itemIndex);
      setTimeout(function () {
        $tabs.hide();
        $target.show();
        setTimeout(function () {
          $target.addClass('active').removeClass('left right');
        }, 50);
      }, 150); //update underline position

      $('.js-underline').css({
        'width': $currentItem.width(),
        'left': $currentItem.position().left + ($currentItem.outerWidth() - $currentItem.width()) / 2
      });
      $('.js-tabs').scrollLeft($('.js-tab-toggle.active').position().left); //on click update tab

      $toggles.on('click', function () {
        $toggles.removeClass('active');
        $(this).addClass('active');
        window.location.hash = $(this).data('slug');
        $currentItem = $('.js-tab-toggle.active');
        itemIndex = $currentItem.data('target');
        $target = $('.js-tab-item[data-tab="tab_' + itemIndex + '"]');
        editPositions(itemIndex);
        setTimeout(function () {
          $tabs.hide();
          $target.show();
          setTimeout(function () {
            $target.addClass('active').removeClass('left right');
          }, 50);
        }, 150); //update underline position

        $('.js-underline').css({
          'width': $currentItem.width(),
          'left': $currentItem.position().left + ($currentItem.outerWidth() - $currentItem.width()) / 2
        });
        $('.js-tabs').scrollLeft($currentItem.position().left);
      }); //on scroll move underline

      $('.js-tabs').on('scroll', function () {
        $('.js-underline').css({
          'width': $currentItem.width(),
          'left': $currentItem.position().left + ($currentItem.outerWidth() - $currentItem.width()) / 2
        });
      });
    };

    var $toggles = $('.js-tab-toggle'),
        $tabs = $('.js-tab-item'),
        tab = $tabs.first().data('tab').slice(-1);
    window.addEventListener("hashchange", hasHash, false);
    document.addEventListener('DOMContentLoaded', function () {
      hasHash();
    }, false);
    ;
    $(function () {
      tabsProduct();
    });
  }

  ;
});